export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref15152.b107c200.jpg";